(function () {
  'use strict';

  var gestureUnlockBound = false;
  var pendingGestureVideos = [];

  function prepareVideo(video, options) {
    if (!video || video.tagName !== 'VIDEO') return;

    var opts = options || {};

    video.defaultMuted = true;
    video.muted = true;
    video.playsInline = true;
    video.loop = opts.loop !== false;
    video.controls = false;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.setAttribute('loop', '');
    video.removeAttribute('controls');
    video.setAttribute('controlsList', 'nodownload nofullscreen noremoteplayback');
    video.setAttribute('disablepictureinpicture', '');

    if (opts.autoplay !== false) {
      video.autoplay = true;
      video.setAttribute('autoplay', '');
    }
  }

  function hasPlayableSource(video) {
    if (!video) return false;
    if (video.currentSrc) return true;
    if (video.getAttribute('src')) return true;
    return !!video.querySelector('source[src]');
  }

  function ensureVideoReady(video, options) {
    var opts = options || {};
    if (!video || video.tagName !== 'VIDEO') return Promise.resolve(false);

    prepareVideo(video, opts);

    if (!hasPlayableSource(video)) {
      return Promise.resolve(false);
    }

    if (video.readyState >= 2) {
      return Promise.resolve(true);
    }

    if (video.preload === 'none' || !video.getAttribute('preload')) {
      video.preload = opts.preload || 'auto';
    }

    return new Promise(function (resolve) {
      var settled = false;

      function finish(ok) {
        if (settled) return;
        settled = true;
        cleanup();
        resolve(!!ok);
      }

      function cleanup() {
        video.removeEventListener('loadeddata', onReady);
        video.removeEventListener('canplay', onReady);
        video.removeEventListener('error', onError);
        window.clearTimeout(timer);
      }

      function onReady() {
        finish(video.readyState >= 2);
      }

      function onError() {
        finish(false);
      }

      var timer = window.setTimeout(function () {
        finish(video.readyState >= 2);
      }, opts.timeout || 10000);

      video.addEventListener('loadeddata', onReady);
      video.addEventListener('canplay', onReady);
      video.addEventListener('error', onError);

      try {
        video.load();
      } catch (error) {
        finish(false);
      }
    });
  }

  function bindGestureUnlock() {
    if (gestureUnlockBound) return;
    gestureUnlockBound = true;

    function retryPending() {
      var videos = pendingGestureVideos.slice();
      pendingGestureVideos = [];

      videos.forEach(function (video) {
        safePlay(video, { skipGestureQueue: true });
      });
    }

    document.addEventListener('pointerdown', retryPending, { once: true, passive: true });
    document.addEventListener('touchstart', retryPending, { once: true, passive: true });
  }

  function queueGestureRetry(video) {
    if (!video || pendingGestureVideos.indexOf(video) !== -1) return;
    pendingGestureVideos.push(video);
    bindGestureUnlock();
  }

  function safePlay(video, options) {
    var opts = options || {};
    if (!video || video.tagName !== 'VIDEO') return Promise.resolve(false);

    return ensureVideoReady(video, opts).then(function (ready) {
      if (!ready) return false;

      prepareVideo(video, opts);

      var playPromise;
      try {
        playPromise = video.play();
      } catch (error) {
        if (!opts.skipGestureQueue) queueGestureRetry(video);
        return false;
      }

      if (!playPromise || typeof playPromise.then !== 'function') {
        return !video.paused;
      }

      return playPromise
        .then(function () {
          return true;
        })
        .catch(function () {
          if (!opts.skipGestureQueue) queueGestureRetry(video);
          return false;
        });
    });
  }

  function pauseVideo(video) {
    if (!video || video.tagName !== 'VIDEO') return;
    if (!video.paused) {
      video.pause();
    }
  }

  function warmVideo(video, options) {
    return ensureVideoReady(video, Object.assign({ preload: 'metadata' }, options || {}));
  }

  window.RabitatVideoPlayback = {
    prepareVideo: prepareVideo,
    ensureVideoReady: ensureVideoReady,
    safePlay: safePlay,
    pauseVideo: pauseVideo,
    warmVideo: warmVideo,
    hasPlayableSource: hasPlayableSource,
  };
})();
